module.exports = __webpack_public_path__ + "static/media/position.d2a21254.svg";